import React from 'react';
import { Zoom } from "react-awesome-reveal";
import { ReactComponent as Logo } from "../icon/logo.svg";
import Social from '../components/Social';
import LinkDataSplitter from '../components/LinkDataSplitter';
import webLinks from '../data/LinkData';

const Header: React.FC = () => {
    return <div className='container'>
        <div className='containerColumn'>
            <Zoom triggerOnce={true}>
                <Logo width={100} className="logo" />
            </Zoom>
            <h3>
                Nicola Sagliano
            </h3>
            <div>
                <h1>
                    Qui trovi tutti i prodotti e i link utili che hai visto nei miei video!
                </h1>
            </div>

            <Social color='var(--white20)'></Social>

            <div className='internalDiv'>
                <LinkDataSplitter links={webLinks} />
            </div>
        </div>
    </div>

}

export default Header